import { useEffect, useState } from 'react';

/**
 * Pays du visiteur, partagé par la langue (LanguageContext) et le prix (lib/pricing.js).
 * Deviné tout de suite par le fuseau (Canada seulement, pour éviter un saut à l'affichage), puis confirmé
 * par Cloudflare (GET /api/geo, netlify-proxy/worker.js), la même source que celle du checkout. Une seule requête.
 */

export const CANADA_ZONES = /^America\/(Toronto|Montreal|Vancouver|Edmonton|Winnipeg|Halifax|Regina|St_Johns|Moncton|Glace_Bay|Goose_Bay|Iqaluit|Whitehorse|Dawson|Dawson_Creek|Fort_Nelson|Creston|Swift_Current|Rankin_Inlet|Resolute|Cambridge_Bay|Inuvik|Yellowknife|Atikokan|Blanc-Sablon|Nipigon|Thunder_Bay|Rainy_River|Pangnirtung)$|^Canada\//;

export function guessCountry() {
  const zone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  return CANADA_ZONES.test(zone) ? 'CA' : '';
}

let request = null;

export function loadCountry() {
  if (!request) {
    request = fetch('/api/geo', { headers: { accept: 'application/json' } })
      .then((res) => (res.ok ? res.json() : null))
      .then((geo) => (typeof geo?.country === 'string' ? geo.country : null))
      .catch(() => null);
  }
  return request;
}

/** Code pays (« CA », « US »…) : deviné d'abord, réel dès que Cloudflare a répondu. */
export function useCountry() {
  const [country, setCountry] = useState(guessCountry);
  useEffect(() => {
    let alive = true;
    loadCountry().then((real) => { if (alive && real !== null) setCountry(real); });
    return () => { alive = false; };
  }, []);
  return country;
}
